/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { createSQRT1_2 } from '../../factoriesAny.js'; // eslint-disable-line camelcase

export var SQRT1_2Dependencies = {
  // eslint-disable-line camelcase
  BigNumberDependencies: BigNumberDependencies,
  createSQRT1_2: createSQRT1_2
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesSQRT1_2.generated.js
// module id = 1503
// module chunks = 0